import React from 'react';
import useLogPage from '../useLogPage';
import LogFilters from '../LogFilters';
import LogTable from '../LogTable';
import LogStatCards from '../LogStatCards';
import { TrendChart, DonutChart } from '../LogCharts';
import { LogService } from '../../../services/activityLogService';

const STATUS_OPTIONS = [
  { value: 'ORDER_CREATED', label: 'Order Created' },
  { value: 'confirmed',     label: 'Confirmed'     },
  { value: 'preparing',     label: 'Preparing'     },
  { value: 'dispatched',    label: 'Dispatched'    },
  { value: 'delivered',     label: 'Delivered'     },
  { value: 'cancelled',     label: 'Cancelled'     },
];

const statusBadge = (v) => {
  const map = {
    order_created: ['#DBEAFE','#1E40AF'],
    placed:        ['#DBEAFE','#1E40AF'],
    confirmed:     ['#D1FAE5','#065F46'],
    preparing:     ['#FEF3C7','#92400E'],
    dispatched:    ['#E0F2FE','#0369A1'],
    delivered:     ['#D1FAE5','#065F46'],
    cancelled:     ['#FEE2E2','#991B1B'],
  };
  const [bg, color] = map[v?.toLowerCase()] || ['#F3F4F6','#374151'];
  return <span className="al-badge" style={{ background: bg, color }}>{v || '—'}</span>;
};

const COLUMNS = [
  { key: 'log_id',        label: '#',            render: (v) => <span className="al-mono">{v}</span> },
  { key: 'order_id',      label: 'Order ID',     render: (v) => <span className="al-mono">{v || '—'}</span> },
  { key: 'username',      label: 'User',         render: (v) => v || '—' },
  { key: 'business_name', label: 'Business',     render: (v) => v || '—' },
  { key: 'from_status',   label: 'From',         render: statusBadge },
  { key: 'to_status',     label: 'To',            render: statusBadge },
  { key: 'notes',         label: 'Details',      render: (v) => <span className="al-truncate" title={v}>{v || '—'}</span> },
  { key: 'created_at',    label: 'Time',         render: (v) => v ? new Date(v).toLocaleString('en-IN') : '—' },
];

const OrderStatusLog = () => {
  const lp = useLogPage(LogService.orderStatus);
  const s = lp.stats || {};

  const handleExport = () => {
    const { search, status, dateFrom, dateTo } = lp.filters;
    LogService.exportOrderStatus({
      ...(search   ? { search }              : {}),
      ...(status   ? { status }              : {}),
      ...(dateFrom ? { date_from: dateFrom } : {}),
      ...(dateTo   ? { date_to:   dateTo   } : {}),
      format: 'excel',
    });
  };

  const stats = [
    { label: 'Total Events',   value: lp.totalItems.toLocaleString(), color: '#F97316' },
    { label: 'Status Changes', value: (s.total_changes ?? lp.totalItems).toLocaleString(), color: '#3B82F6' },
  ];

  const donutData = lp.donut.length
    ? lp.donut
    : Object.entries(s.breakdown || {}).map(([name, value]) => ({ name, value }));

  return (
    <div className="al-page">
      <LogStatCards stats={stats} />

      <div className="al-charts">
        <TrendChart title="Order Status Changes Over Time" data={lp.trend} color="#F97316" />
        <DonutChart  title="Status Distribution"   data={donutData} />
      </div>

      <LogFilters
        filters={lp.filters}
        onFilterChange={lp.handleFilterChange}
        onApply={lp.handleApply}
        onReset={lp.handleReset}
        statusOptions={STATUS_OPTIONS}
        loading={lp.loading}
      />

      <LogTable
        title="Order Status Logs"
        columns={COLUMNS}
        rows={lp.rows}
        loading={lp.loading}
        error={lp.error}
        page={lp.page}
        totalPages={lp.totalPages}
        totalItems={lp.totalItems}
        pageSize={lp.filters.pageSize}
        onPageChange={lp.handlePageChange}
        onExport={handleExport}
        onRefresh={lp.handleRefresh}
      />
    </div>
  );
};

export default OrderStatusLog;
